export const LOCALES = {
  ENG: 'en-us',
  DE: 'de-de',
};
